import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=055f667d&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=ts"
export * from "./ProductGallery.vue?vue&type=script&lang=ts"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=055f667d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f667d",
  null
  
)

export default component.exports